import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

// Importa los estilos de Bootstrap desde un archivo personalizado o directamente
// import './assets/styles.scss'; // Tu archivo SCSS personalizado
// Si no necesitas personalización, puedes usar el CSS compilado directamente:


import 'bootstrap/dist/css/bootstrap.min.css';

// Importa los scripts de Bootstrap (opcional, si usas funcionalidades como popovers, tooltips)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import $ from 'jquery';

// Asigna jQuery a window (requerido para algunas bibliotecas)
window.$ = $;
window.jQuery = $;

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import 'primeicons/primeicons.css'

import VAnimateCss from 'v-animate-css';





const app = createApp(App);
app.use(createPinia());
app.use(VueTelInput);
app.use(router);
app.use(ConfirmationService);
app.use(ToastService);
app.use(VAnimateCss);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none',
        }
    }
});

app.mount('#app');